import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SMTPInfo.css';
import SMTPManagement from '../../../components/siteadmin/SMTPManagement/SMTPManagement';

class SMTPInfo extends React.Component {

  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getAllSmtpData: PropTypes.array,
    })
  };

  static defaultProps = {
    data: {
      loading: true
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1
    }
  }

  setStateVariable = (variables) => {
    this.setState(variables);
  }

  render() {
    const { currentPage } = this.state;

    return <SMTPManagement
      setStateVariable={this.setStateVariable}
      currentPage={currentPage}
    />
  }
}

export default withStyles(s)(SMTPInfo);